import React, { FC } from 'react';
import { TextProps } from './types';
import { StyledText } from './text.style';

const Text: FC<TextProps> = ({ fontLevel = 'base', align = 'inherit', fontWeight = 'normal', colorKey = 'textPrimary', element = 'p', className = '', children, ...rest }) => (
    <StyledText
        className={className}
        element={element}
        fontLevel={fontLevel}
        fontWeight={fontWeight}
        colorKey={colorKey}
        align={align}
        {...rest}
    >
        {children}
    </StyledText>
);

export default Text;
